export default __webpack_public_path__ + "static/media/total_pinacate@2x.0546cce1.png";